const currencydata = [
  {
    id: "USD",
    title: "USD",
    symbol: "$",
  },
  {
    id: "GBP",
    title: "Great Brittan Pound",
    symbol: "£",
  },
  {
    id: "EUR",
    title: "Euro",
    symbol: "€",
  },
];

export default currencydata;
